import React, { lazy, Component } from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, ClockIcon, PhoneIcon, InstagramIcon, FacebookIcon } from 'lucide-react';
export function Location() {
  const handleWhatsApp = () => {
    const message = encodeURIComponent('Hola! Quiero consultar sobre los productos y servicios de La Victoria II.');
    window.open(`https://wa.me/5492665013601?text=${message}`, '_blank');
  };
  const handleGoogleMaps = () => {
    window.open('https://www.google.com/maps/search/?api=1&query=San+Martin+1090,+San+Luis,+Argentina', '_blank');
  };
  return <section id="contacto" className="py-20 bg-secondary-cream-dark" data-id="element-90">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-92">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-secondary-brown mb-4" data-id="element-93">
            Ubicación y Contacto
          </h2>
          <p className="text-lg text-secondary-brown-light" data-id="element-94">
            Visitanos o contactanos para cualquier consulta
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-95">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-2xl shadow-lg" data-id="element-96">
            <h3 className="text-2xl font-serif font-semibold text-secondary-brown mb-6" data-id="element-97">
              Información de Contacto
            </h3>

            <div className="space-y-6" data-id="element-98">
              <div className="flex items-start space-x-4" data-id="element-99">
                <MapPinIcon className="text-primary-yellow flex-shrink-0 mt-1" size={24} data-id="element-100" />
                <div data-id="element-101">
                  <p className="font-semibold text-secondary-brown mb-1" data-id="element-102">
                    Dirección
                  </p>
                  <p className="text-secondary-brown-light" data-id="element-103">
                    San Martin 1090, San Luis
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4" data-id="element-104">
                <ClockIcon className="text-primary-yellow flex-shrink-0 mt-1" size={24} data-id="element-105" />
                <div data-id="element-106">
                  <p className="font-semibold text-secondary-brown mb-1" data-id="element-107">
                    Horarios
                  </p>
                  <p className="text-secondary-brown-light" data-id="element-108">
                    Lunes a Viernes: 7:00 - 21:00
                  </p>
                  <p className="text-secondary-brown-light" data-id="element-109">
                    Sábados y Domingos: 8:00 - 15:00
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4" data-id="element-110">
                <PhoneIcon className="text-primary-yellow flex-shrink-0 mt-1" size={24} data-id="element-111" />
                <div data-id="element-112">
                  <p className="font-semibold text-secondary-brown mb-1" data-id="element-113">
                    Teléfono / WhatsApp
                  </p>
                  <p className="text-secondary-brown-light" data-id="element-114">
                    +54 9 2665 01-3601
                  </p>
                </div>
              </div>

              <div className="pt-4" data-id="element-115">
                <p className="font-semibold text-secondary-brown mb-3" data-id="element-116">
                  Redes Sociales
                </p>
                <div className="flex space-x-4" data-id="element-117">
                  <a href="https://www.instagram.com/panaderialavictoria2?igsh=MWtyOHdmYnYxd2Nxbw==" target="_blank" rel="noopener noreferrer" className="bg-primary-yellow p-3 rounded-full hover:bg-primary-gold transition-colors" aria-label="Instagram" data-id="element-118">
                    <InstagramIcon className="text-secondary-brown" size={20} data-id="element-119" />
                  </a>
                </div>
              </div>

              <div className="pt-4 space-y-3" data-id="element-120">
                <button onClick={handleWhatsApp} className="w-full bg-primary-yellow text-secondary-brown px-6 py-3 rounded-full font-semibold hover:bg-primary-gold transition-colors" data-id="element-121">
                  Contactar por WhatsApp
                </button>
                <button onClick={handleGoogleMaps} className="w-full bg-secondary-brown text-white px-6 py-3 rounded-full font-semibold hover:bg-secondary-brown-light transition-colors" data-id="element-122">
                  Cómo Llegar
                </button>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="rounded-2xl overflow-hidden shadow-lg h-[500px]" data-id="element-123">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3334.426618585488!2d-66.3391783!3d-33.3000000!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95d43ea123456789%3A0x123456789abcdef!2sSan%20Martin%201090%2C%20San%20Luis%2C%20Argentina!5e0!3m2!1sen!2sar!4v1610000000000!5m2!1sen!2sar" width="100%" height="100%" style={{
            border: 0
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Ubicación de La Victoria II" data-id="element-124" />
          </motion.div>
        </div>
      </div>
    </section>;
}